import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import { registerUserService } from "../services/auth/register";
import UserRole from "../interfaces/UserRole";
import type { Referente } from "../firebase/firestore/usuarios";
import { useUsuariosStore } from "../zustand/useUsuariosStore";

export default function useCreateUserHook(onSuccess?: () => void) {
  const { fetchAllUsuarios, resetUsuarios } = useUsuariosStore();
  const [loading, setLoading] = useState(false);

  // Validaciones
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("El nombre es obligatorio"),
    lastName: Yup.string().required("El apellido es obligatorio"),
    email: Yup.string()
      .email("Correo inválido")
      .required("El correo es obligatorio"),
    countryCode: Yup.string()
      .matches(/^\+\d{1,4}$/, "Prefijo inválido")
      .required("El prefijo es obligatorio"),
    phone: Yup.string()
      .matches(/^\d{7,12}$/, "Número de teléfono inválido")
      .required("El teléfono es obligatorio"),
    password: Yup.string()
      .min(6, "La contraseña debe tener al menos 6 caracteres")
      .required("La contraseña es obligatoria"),
    role: Yup.mixed<UserRole>()
      .oneOf(Object.values(UserRole), "El rol debe ser Admin, Digitador o Cliente")
      .required("El rol es obligatorio"),
  });

  // Formik para manejar el formulario
  const formik = useFormik({
    initialValues: {
      name: "",
      lastName: "",
      email: "",
      countryCode: "",
      phone: "",
      password: "",
      role: UserRole.Admin,
      vendedor: undefined as Referente | undefined,
      referidoPor: undefined as Referente | undefined,
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);

      try {
        const user = await registerUserService({
          ...values,
          role: values.role,
          vendedor: values.vendedor || undefined,
          referidoPor: values.referidoPor || undefined,
        });
        if (user) {
          resetUsuarios();
          await fetchAllUsuarios();
          if (onSuccess) {
            onSuccess();
          }
        }
      } catch (err) {
        console.log({ err });
      } finally {
        setLoading(false);
      }
    },
  });

  return { ...formik, loading };
}
